import { defineDirective, IOmniaSession, IOmniaShell, shell } from "../../omnia"
import { IFieldsService } from "../../types"
import { CropVM } from "../vm/crop"

import m = omnia.models;

export class YieldScalesCreateDialog extends shell.Dialog {

    static create(): ng.IDirective {
        return defineDirective(YieldScalesCreateDialog, "app/datalayers/yield-scales/create/create.html");
    }

    static $inject = ["$scope", "OmniaShell", "OmniaSession", "OmniaFieldsService"];

    public gradient2Mode: boolean;

    public color1: number[];
    public color2: number[];
    public color3: number[];

    public intervals: number;
    public crops: CropVM[];
    public minYield: number;
    public maxYield: number;

    public years: number[] = []

    private _selectedCrop: CropVM;

    public form: ng.IFormController;
    public ready: boolean;

    constructor($scope: ng.IScope, protected shell: IOmniaShell, private session: IOmniaSession, private fieldsSvc: IFieldsService) {
        super($scope, shell);

        this.setup();
    }

    get selectedCrop(): CropVM {
        return this._selectedCrop;
    }

    set selectedCrop(value: CropVM) {
        this._selectedCrop = value;
    }

    protected setup() {

        this.fieldsSvc.refresh().then(r => {

            this.crops = this.fieldsSvc.crops
                .filter(c => c.TargetYieldReqd || c.Grass)
                .map(c => new CropVM(c))

            this.years = this.session.getCroppingYears()
                .filter(y => y.YearId >= this.session.yearId)
                .map(y => y.YearId)

            this.gradient2Mode = false;
            this.color1 = [246, 56, 59];
            this.color2 = [255, 224, 64];
            this.color3 = [70, 168, 96];

            this.ready = true;
        });

    }

    canCommit(): boolean {

        return this.form && this.form.$valid && this.selectedCrop && this.intervals > 2 && this.intervals <= 10;

    }

    commit() {

        if (!this.canCommit()) return;

        var colors = [this.color1, this.color2];

        if (!this.gradient2Mode) {
            colors.push(this.color3);
        }

        var gradient = omnia.color.createLinearGradient(colors, this.intervals);

        var scale = <m.ICropYieldScale>{
            CropId: this.selectedCrop.id,
            HoldingId: this.session.holdingId,
            Intervals: this.intervals,
            MapStyle: gradient,
            MinYield: this.minYield,
            MaxYield: this.maxYield,
            Years: this.years
        };

        this.close(scale);

    }

}
